
import tooltips from './tooltips'
 
const install = function(Vue) {
  Vue.directive('el-tooltips', tooltips)
}
 
if (window.Vue) {
  window['el-tooltips'] = tooltips
  Vue.use(install); // eslint-disable-line
}
 
tooltips.install = install
export default tooltips
